import { render, staticRenderFns } from "./GenerateCodigos.vue?vue&type=template&id=52991234"
import script from "./GenerateCodigos.vue?vue&type=script&lang=js"
export * from "./GenerateCodigos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports